import React from 'react'
import { IonItem, IonLabel } from '@ionic/react'
import './DropdownListSelect.component.css'

export interface IDropdownListSelectProps {
  isOpen: boolean
  onClose: () => void
  options: any[]
  selectedOption: any
  actionHandler: (option: any) => void
  icon?: React.ReactNode
  detail?: boolean
  lines?: 'none' | 'inset' | 'full'
  dataTestId: string
}

const DropdownListSelectComponent: React.FC<IDropdownListSelectProps> = ({
  isOpen,
  options,
  selectedOption,
  actionHandler,
  icon,
  detail = false,
  lines = 'none',
  dataTestId,
}) => {
  const isSelected = options?.some((option: any) => option?.id === selectedOption?.id)
  const filterDisplayOptions = options.filter((option) => !option.hide)

  return (
    <div
      id='DropdownListSelect'
      data-testid={dataTestId}
      tabIndex={1}
      className={`dropdown-select-options ${isOpen ? 'active' : ''}`}>
      {filterDisplayOptions.map((option) => (
        <IonItem
          id='DropdownSelectItem'
          data-testid={`Option_${option.id}`}
          key={option.id}
          button
          detail={detail}
          lines={lines}
          className='dropdown-select-option'
          onClick={() => actionHandler(option)}>
          {icon && isSelected && (
            <IonLabel className='icon-label'>{selectedOption?.id === option?.id && icon}</IonLabel>
          )}
          <IonLabel
            id={`optionLabel_${option.id}`}
            className={`option-labels ${selectedOption?.id === option?.id ? 'selected-option' : ''}`}>
            {option?.name}
          </IonLabel>
        </IonItem>
      ))}
    </div>
  )
}

export default DropdownListSelectComponent
